/*
 * PAWS & PEARLS — SECRET SKY — THE FLYING TOAD'S LITTLE FRIEND V1
 * 28 October 2026 | ADD-ON ONLY for the MAGICAL MUSE WORLD theme
 *
 * Makes a SECOND, smaller pearl-and-rose-gold flying toad that travels
 * beside the already-installed original, but has its own bobbing, approach,
 * little dives, turns, wing-frame timing, and tilt.
 *
 * READ-ONLY dependency: the existing #pp-muse-flying-toad-layer-v1
 * .pp-toad-actor. This add-on copies its CURRENT atlas background-image.
 * NO second atlas or extra images needed; NO changes to original V1 code.
 * NO audio. NO changes to V18, sky scrolling, clouds, companions, hippo,
 * Lilla, birds, sound, pearls, and other House animations.
 *
 * ROLLBACK: remove ONLY this add-on's <script> tag. The original remains.
 */
(function () {
  'use strict';

  var NS = 'ppMuseFlyingToadFriendV1';
  if (window[NS] && window[NS].installed) return;

  // MADAM'S ADJUSTMENT DESK — nothing below this block needs editing for QA.
  var CONFIG = Object.freeze({
    RELATIVE_SIZE: 0.72,       // Friend is 72% of the original toad's size.
    JOIN_DELAY_MS: 550,       // A little late, as though catching up to a friend.
    FADE_IN_MS: 450,
    RIGHT_DISTANCE: 1.03,    // Centre-to-centre gap as a fraction of leader's size.
    HORIZONTAL_PLAY: 0.23,  // Independent little forward/backward excursions.
    VERTICAL_PLAY: 0.34,    // Independent floating, dips, and little upward jumps.
    Z_INDEX: 2147483001,    // Just behind the original toad (2147483002).
    MIN_DESKTOP_PX: 52,
    MAX_DESKTOP_PX: 126,
    MIN_MOBILE_PX: 42,
    MAX_MOBILE_PX: 88
  });

  var LAYER_ID = 'pp-muse-flying-toad-friend-layer-v1';
  var STYLE_ID = LAYER_ID + '-style';
  var LEADER_SELECTOR = '#pp-muse-flying-toad-layer-v1 .pp-toad-actor';
  var SKY_ID = 'pp-muse-secret-sky';
  var STAGE_ID = 'pp-muse-balloon-stage';
  var layer = null;
  var actor = null;
  var pollTimer = 0;
  var frameId = 0;
  var firstVisibleAt = 0;
  var watching = false;
  var watchStartedAt = 0;
  var lastPose = -1;
  var copiedAtlas = '';

  function clamp(lo, v, hi) { return Math.max(lo, Math.min(v, hi)); }
  function isSky() {
    return document.documentElement.classList.contains('pp-muse-secret-sky-page');
  }
  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function leader() { return document.querySelector(LEADER_SELECTOR); }
  function hide() { if (actor) { actor.style.display = 'none'; actor.style.opacity = '0'; } }

  // Same *visible artwork rectangle* as the original; respect scroll/cropping.
  function visibleSky() {
    var sky = document.getElementById(SKY_ID);
    var wrapper = document.querySelector('.page-wrapper');
    if (!sky || !wrapper || !wrapper.contains(sky)) return null;
    var a = sky.getBoundingClientRect();
    var b = wrapper.getBoundingClientRect();
    var scene = sky.querySelector('.pp-muse-sky-scene');
    if (scene) {
      var s = scene.getBoundingClientRect();
      if (s.width > 100 && s.height > 100) {
        a = {left:Math.max(a.left,s.left), top:Math.max(a.top,s.top),
          right:Math.min(a.right,s.right), bottom:Math.min(a.bottom,s.bottom)};
      }
    }
    var x1 = Math.max(0,a.left,b.left);
    var y1 = Math.max(0,a.top,b.top);
    var x2 = Math.min(window.innerWidth,a.right,b.right);
    var y2 = Math.min(window.innerHeight,a.bottom,b.bottom);
    if (x2-x1 < 210 || y2-y1 < 240) return null;
    return {left:x1,right:x2,top:y1,bottom:y2};
  }

  function makeLayer() {
    if (layer && layer.isConnected) return true;
    var sky = document.getElementById(SKY_ID);
    var stage = document.getElementById(STAGE_ID);
    var wrapper = document.querySelector('.page-wrapper');
    if (!isSky() || !sky || !stage || !wrapper ||
        !wrapper.contains(sky) || !wrapper.contains(stage)) return false;

    if (!document.getElementById(STYLE_ID)) {
      var sheet = document.createElement('style');
      sheet.id = STYLE_ID;
      sheet.textContent =
        '#' + LAYER_ID + '{position:fixed!important;inset:0!important;' +
        'z-index:' + CONFIG.Z_INDEX + '!important;overflow:hidden!important;' +
        'pointer-events:none!important;user-select:none!important;}' +
        '#' + LAYER_ID + ' .pp-toad-little-friend{' +
        'position:absolute!important;left:0;top:0;display:none;' +
        'width:70px;height:70px;aspect-ratio:1/1;' +
        'background-size:600% 400%;background-repeat:no-repeat;' +
        'pointer-events:none!important;user-select:none!important;' +
        'will-change:transform,left,top;}' +
        '@media(prefers-reduced-motion:reduce){#' + LAYER_ID + '{display:none!important;}}';
      document.head.appendChild(sheet);
    }

    layer = document.createElement('div');
    layer.id = LAYER_ID;
    layer.setAttribute('aria-hidden','true');
    actor = document.createElement('div');
    actor.className = 'pp-toad-little-friend';
    layer.appendChild(actor);
    document.body.appendChild(layer);
    return true;
  }

  // The original movement atlas has six columns and four rows.
  // This independent pose schedule is intentionally NOT the original's.
  function frameNumber(t) {
    if (t < 1.7) return 1 + (2 + Math.floor(t / .39)) % 6;
    if (t < 7.0) return 7 + (4 + Math.floor((t-1.7) / .23)) % 12;
    if (t < 8.8) return 19 + (2 + Math.floor((t-7.0) / .36)) % 6;
    if (t < 14.1) return 7 + (9 + Math.floor((t-8.8) / .27)) % 12;
    if (t < 15.7) return 19 + (4 + Math.floor((t-14.1) / .42)) % 6;
    return 1 + (5 + Math.floor((t-15.7) / .4)) % 6;
  }
  function setPose(n) {
    if (!actor || n === lastPose) return;
    lastPose = n;
    var col = (n-1) % 6, row = Math.floor((n-1)/6);
    actor.style.backgroundPosition = (col*20) + '% ' + (row*100/3).toFixed(5) + '%';
  }

  function draw(now) {
    frameId = 0;
    if (!watching || document.hidden || reducedMotion() || !isSky()) { hide(); return; }
    var original = leader();
    if (!original || original.style.display !== 'block') { hide(); return; }
    if (!makeLayer()) { hide(); return; }
    var bounds = visibleSky();
    if (!bounds) { hide(); return; }

    var originalStyle = window.getComputedStyle(original);
    var bg = originalStyle.backgroundImage;
    if (!bg || bg === 'none') { hide(); return; }
    if (copiedAtlas !== bg) {
      actor.style.backgroundImage = bg;  // Same approved 24-frame atlas, no new asset.
      copiedAtlas = bg;
    }

    var age = now - firstVisibleAt - CONFIG.JOIN_DELAY_MS;
    if (age < 0) { hide(); frameId = requestAnimationFrame(draw); return; }
    var t = age / 1000;
    var leaderX = parseFloat(original.style.left);
    var leaderY = parseFloat(original.style.top);
    var leaderW = parseFloat(original.style.width);
    if (!isFinite(leaderX) || !isFinite(leaderY) || !isFinite(leaderW) || leaderW <= 0) {
      hide(); return;
    }
    var mobile = window.innerWidth < 768;
    var width = clamp(mobile ? CONFIG.MIN_MOBILE_PX : CONFIG.MIN_DESKTOP_PX,
      leaderW * CONFIG.RELATIVE_SIZE * (1 + .035*Math.sin(t*1.3)),
      mobile ? CONFIG.MAX_MOBILE_PX : CONFIG.MAX_DESKTOP_PX);

    // Follow its friend, but not in lockstep. Swoop ahead and fall back,
    // rise, dip, and occasionally turn while staying close to the leader.
    var dx = leaderW * (CONFIG.RIGHT_DISTANCE +
      CONFIG.HORIZONTAL_PLAY*Math.sin(t*.88+.3) + .11*Math.sin(t*2.07));
    var dy = leaderW * (-.31 +
      CONFIG.VERTICAL_PLAY*Math.sin(t*1.24+1.0) + .13*Math.sin(t*2.26+.8));
    var x = clamp(bounds.left+width/2+3, leaderX+dx, bounds.right-width/2-3);
    var y = clamp(bounds.top+width/2+3, leaderY+dy, bounds.bottom-width/2-3);
    var tilt = 5.5*Math.sin(t*1.6+.7) - 3.2*Math.sin(t*.82);
    // Two passing glances toward its companion (independent of the leader).
    var lookingBack = (t > 5.9 && t < 7.0) || (t > 12.4 && t < 14.1);

    setPose(frameNumber(t));
    actor.style.left = x.toFixed(1) + 'px';
    actor.style.top = y.toFixed(1) + 'px';
    actor.style.width = width.toFixed(1) + 'px';
    actor.style.height = width.toFixed(1) + 'px';
    actor.style.transform = 'translate3d(-50%,-50%,0) rotate(' + tilt.toFixed(2) +
      'deg) scaleX(' + (lookingBack ? -1 : 1) + ')';
    actor.style.opacity = String(clamp(0,age/CONFIG.FADE_IN_MS,1));
    actor.style.display = 'block';
    frameId = requestAnimationFrame(draw);
  }

  function stop() {
    watching = false;
    if (pollTimer) { clearInterval(pollTimer); pollTimer = 0; }
    if (frameId) { cancelAnimationFrame(frameId); frameId = 0; }
    firstVisibleAt = 0;
    watchStartedAt = 0;
    lastPose = -1;
    hide();
  }
  function poll() {
    if (!watching || !isSky() || document.hidden || reducedMotion()) { stop(); return; }
    // Guard against orphaned intervals if the first toad never starts/loads.
    if (performance.now() - watchStartedAt > 62000) { stop(); return; }
    var original = leader();
    var status = window.ppMuseFlyingToadV1 &&
      typeof window.ppMuseFlyingToadV1.getStatus === 'function'
      ? window.ppMuseFlyingToadV1.getStatus() : null;
    if (firstVisibleAt && status && !status.running) { stop(); return; }
    if (!original || original.style.display !== 'block') {
      hide();
      if (frameId) { cancelAnimationFrame(frameId); frameId = 0; }
      return;
    }
    if (!firstVisibleAt) firstVisibleAt = performance.now();
    if (!frameId) frameId = requestAnimationFrame(draw);
  }
  function start(event) {
    if (watching || reducedMotion() || !isSky()) return;
    var target = event.target && event.target.closest && event.target.closest(
      '#pp-muse-balloon-stage .pp-balloon, .pp-muse-flight-overlay.pp-balloon');
    if (!target || !target.classList.contains('pp-muse-flight-overlay')) return;
    // Do not alter or invoke the original: only observe its own run.
    watching = true;
    watchStartedAt = performance.now();
    pollTimer = setInterval(poll, 140);
    poll();
  }
  function unload(event) {
    var stage = document.getElementById(STAGE_ID);
    if (event.target && stage && event.target.contains(stage)) {
      stop();
      if (layer) layer.remove();
      layer = null; actor = null; copiedAtlas = '';
    }
  }

  document.addEventListener('click', start, false);
  document.addEventListener('shopify:section:unload', unload);
  window.addEventListener('pagehide', stop);
  document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); });

  window[NS] = {
    version:'1.0-companion-read-only-atlas',
    installed:true,
    getStatus:function () {
      return {watching:watching,visible:!!(actor && actor.style.display === 'block'),
        usesOriginalAtlas:true,hasAudio:false,changesOriginalFlight:false,
        relativeSize:CONFIG.RELATIVE_SIZE,layerPresent:!!(layer&&layer.isConnected)};
    }
  };
})();
